import React from 'react';
import { motion } from 'framer-motion';
import { FaBuilding, FaDog, FaHamburger, FaPaw, FaShoppingBag, FaShoppingCart, FaStethoscope, FaTools, FaTshirt } from 'react-icons/fa';

const areas = [
  { icon: FaTshirt, name: 'Lojas de confecções' },
  { icon: FaShoppingBag, name: 'Calçados e acessórios' },
  { icon: FaBuilding, name: 'Imobiliárias' },
  { icon: FaShoppingCart, name: 'Mercados' },
  { icon: FaTools, name: 'Materiais de construção' },
  { icon: FaStethoscope, name: 'Clínicas de atendimento' },
  { icon: FaHamburger, name: 'Lanchonetes e food service' },
  { icon: FaDog, name: 'Lojas veterinárias' },
  { icon: FaPaw, name: 'Pet shops' },
];

const pastelColors = ['#3B9ED4', '#5BACD1', '#2178AB', '#6BBDDF', '#4A90C4', '#7DC4E8'];

const variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      staggerChildren: 0.06,
    },
  },
};

const itemVariant = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0 },
};

function Clients() {
  return (
    <section id="clients" className="section-padding" style={{ background: 'linear-gradient(180deg, #EBF6FC 0%, #FAFEFF 100%)' }}>
      <div className="container">
        <motion.div
          className="section-header text-center"
          initial="hidden"
          animate="visible"
          variants={variants}
        >
          <motion.p
            variants={itemVariant}
            style={{
              display: 'inline-flex',
              padding: '8px 14px',
              borderRadius: '9999px',
              background: 'rgba(59,158,212,0.08)',
              color: '#2178AB',
              fontWeight: 700,
              marginBottom: '18px',
            }}
          >
            Flexibilidade real
          </motion.p>
          <motion.h2 variants={itemVariant} className="section-title">
            Segmentos atendidos com a mesma lógica: fluxo claro e operação estável.
          </motion.h2>
          <motion.p variants={itemVariant} style={{ maxWidth: '720px', margin: '0 auto 40px', color: '#4A6680' }}>
            Nossa base de produto e customização permite atender desde varejo até clínica, sem perder consistência de processo.
          </motion.p>
        </motion.div>

        <motion.div
          className="row justify-content-center"
          initial="hidden"
          animate="visible"
          variants={variants}
        >
          {areas.map((area, index) => {
            const color = pastelColors[index % pastelColors.length];
            const Icon = area.icon;

            return (
              <div key={area.name} className="col-lg-4 col-md-6 col-12 mb-4">
                <motion.article
                  variants={itemVariant}
                  whileHover={{ y: -6, boxShadow: `0 18px 36px ${color}20` }}
                  style={{
                    background: 'rgba(255,255,255,0.92)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: '24px',
                    padding: '28px',
                    minHeight: '100%',
                    border: `1px solid ${color}22`,
                    boxShadow: '0 8px 24px rgba(59,158,212,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '18px',
                    cursor: 'default',
                  }}
                >
                  <div
                    style={{
                      width: '68px',
                      height: '68px',
                      borderRadius: '20px',
                      background: `linear-gradient(135deg, ${color}18, ${color}30)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: `0 10px 20px ${color}18`,
                      flexShrink: 0,
                    }}
                  >
                    <Icon size={32} color={color} />
                  </div>

                  <div>
                    <p style={{ color: '#6A8899', fontWeight: 700, fontSize: '0.78rem', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      Segmento
                    </p>
                    <h3 style={{ color: '#1A2D3A', fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>
                      {area.name}
                    </h3>
                  </div>
                </motion.article>
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}

export default Clients;
